module.exports = __webpack_public_path__ + "media/site/images/svg/logos/ceod-logo-text-white-f386fb4e4e514bed15c30d206252a042.svg";